import * as type from './type';

const initialState = {
  data: [],
  metadata: {},
  obj: {},
  isCreate: false,
  isUpdate: false,
  loading: false,
  isDelete: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case type.GET_MEDIA_LIST:
      return {
        ...state,
        data: action.data.data,
      };


    default:
      return state;
  }
};
